import apiClient from "./apiClient";
// ✅ Fetch all blogs with pagination
export const fetchBlogsAPI = async (page = 1) => {
  return apiClient.get(`/tailmission/api/v1/admin/blogs?page=${page}`);
};

// ✅ Fetch a single blog by ID
export const fetchBlogByIdAPI = (id) => {
  return apiClient.get(`/tailmission/api/v1/admin/blogs/${id}`);
};

// ✅ Delete a blog by ID
export const deleteBlogAPI = (id) => {
  return apiClient.delete(`/tailmission/api/v1/admin/blogs/${id}`);
};

// ✅ Update a blog by ID
export const updateBlogAPI = (id, data) => {
  console.log('BlogAPI: Updating blog:', { id, data });

  // Check if data is FormData (for proper backend format)
  const isFormData = data instanceof FormData;

  const config = {
    headers: {
      ...(isFormData && { 'Content-Type': 'multipart/form-data' })
    }
  };

  return apiClient.put(`/tailmission/api/v1/admin/blogs/${id}`, data, config);
};

// ✅ Create a new blog
export const createBlogAPI = (data) => {
  // Check if data is FormData (for proper backend format)
  const isFormData = data instanceof FormData;

  const config = {
    headers: {
      ...(isFormData && { 'Content-Type': 'multipart/form-data' })
    }
  };

  return apiClient.post(`/tailmission/api/v1/admin/blogs`, data, config);
};

// ✅ Publish a blog
export const publishBlogAPI = (id) => {
  return apiClient.patch(`/tailmission/api/v1/admin/blogs/${id}/publish`, {});
};

// ✅ Unpublish a blog
export const unpublishBlogAPI = (id) => {
  return apiClient.patch(`/tailmission/api/v1/admin/blogs/${id}/unpublish`, {});
};

// ✅ Archive a blog
export const archiveBlogAPI = (id) => {
  return apiClient.patch(`/tailmission/api/v1/admin/blogs/${id}/archive`, {});
};

// ✅ Unarchive a blog
export const unarchiveBlogAPI = (id) => {
  return apiClient.patch(`/tailmission/api/v1/admin/blogs/${id}/unarchive`, {});
};
